import { render } from "./Login.vue?vue&type=template&id=01640a67&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=01640a67&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01640a67"

export default script